import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({

  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  menuItem: {
    display: 'flex',
    gap: '8px'
  },
  avatarBox: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%'
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  contactName: {
    fontWeight: 'bold',
    fontSize: '.875rem',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  contactNumber: {
    fontSize: '.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  avatar: {
    // width: 32,
    // height: 32,
  },
  grey: {
    backgroundColor: '#9e9e9e'
  },
  blue: {
    backgroundColor: '#2196f3'
  },
  cyan: {
    backgroundColor: '#00bcd4'
  },
  purple: {
    backgroundColor: '#9c27b0'
  }
}))
